export class EmailEstudo {
    public id: number;
    public codigoEstudoSocioEconomico: number;
    public descricao: string;
    public de: string;
    public para: string;
    public data: Date;
}
